import React, { useState } from "react";
import { Button, Form, Space, Input, Typography } from "antd";
import axios from "../shared/axios";
import { Label } from "recharts";

const { Title, Text } = Typography;

const ResetPassword = () => {
  const [email, setEmail] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newPasswordTwo, setNewPasswordTwo] = useState("");
  const [success, setSuccess] = useState(false);

  const emailHandler = (event) => {
    setEmail(document.getElementById("email").value);
    console.log("Email: ", document.getElementById("email").value);
  };

  const passwordHandler = (event) => {
    setNewPassword(document.getElementById("new-password").value);
    console.log(
      "New Password One: ",
      document.getElementById("new-password").value
    );
  };

  const passwordTwoHandler = (event) => {
    setNewPasswordTwo(document.getElementById("new-password-two").value);
    console.log(
      "New Password Two: ",
      document.getElementById("new-password-two").value
    );
  };

  const resetPassword = (props) => {
    axios
      .post(`${process.env.REACT_APP_BACKEND_URL}/reset-password`, {
        password: newPassword,
        passwordTwo: newPasswordTwo,
        email: email,
      })
      .then((response) => {
        setSuccess(true);
        console.log("Reset Password Response: ", response);
      })
      .catch((error) => {
        console.log("Error resetting passwaord in the backend:", error);
        alert("Reset Password failed!");
      });
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <Title>Reset Password For Users</Title>
      <Text>Help users on the learning portal reset their password</Text>
      <Text>Password needs to have the following criteria:</Text>
      <Text>1. More than 8 characters</Text>
      <Text>2. At least 1 upper case character</Text>
      <Text>3. At least 1 lower case character</Text>
      <Text>4. At least 1 numbere character</Text>
      <Text>Example: nasacademyWAVE50</Text>
      <br />

      <section>
        <Space align="baseline">
          <Form align="center" onFinish={resetPassword}>
            <Label>Email</Label>
            <Input
              style={{ marginBottom: "10px" }}
              placeholder="Email"
              onChange={emailHandler}
              type="text"
              id="email"
            />
            <Input
              style={{ marginBottom: "10px" }}
              placeholder="Enter new password"
              onChange={passwordHandler}
              type="text"
              id="new-password"
            />
            <Input
              style={{ marginBottom: "10px" }}
              placeholder="Validate new password"
              onChange={passwordTwoHandler}
              type="text"
              id="new-password-two"
            />
            <Button type="primary" htmlType="submit">
              Reset
            </Button>
          </Form>
        </Space>
      </section>
      {success ? (
        <>
          <section
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              margin: "20px",
            }}
          >
            <Title level={4}>SUCCESS!</Title>
          </section>
        </>
      ) : (
        <div />
      )}
    </div>
  );
};

export default ResetPassword;
